import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { STORE_HOTLINE, STORE_HOTLINE_TEL } from "../contants";
import { getCurrentStoreConfig } from "../tenant";
import { getStoreById } from "../server/store";

export function useStoreHotline() {
  const storeId = useMemo(() => {
    if (typeof window === "undefined") {
      return null;
    }
    return getCurrentStoreConfig()?.id ?? null;
  }, []);

  const query = useQuery({
    queryKey: ["store-hotline", storeId],
    queryFn: () => getStoreById(storeId ?? ""),
    enabled: !!storeId,
    staleTime: 1000 * 60 * 100,
    refetchOnWindowFocus: false,
  });

  const responsePhone =
    (query.data as any)?.phoneNumber ??
    (query.data as any)?.PhoneNumber ??
    (query.data as any)?.hotline ??
    null;

  const hotline = responsePhone || STORE_HOTLINE;
  const hotlineTel =
    responsePhone?.replace?.(/[^\d+]/g, "") || STORE_HOTLINE_TEL;

  return {
    hotline,
    hotlineTel,
    ...query,
  };
}
